import constant from '../../constant'

const initialState = { 
  comments: false,
  totalNum: 'wx'
};

export function commentNew (state = initialState, action) {
  switch (action.type) {
    case constant.COMMENT.GET_HOT_COMMENT_NEW:
      return {
        ...state,
        ...action.commentNew
      }
    default:
      return state
  }
}